class UtpTheme {
  constructor() {
    this.drawer = document.querySelector('[data-cart-drawer]');
    this.scrim = document.querySelector('[data-drawer-close].drawer-scrim');
    this.bind();
    this.updateTotals();
    this.applyChannelFunnel();
  }
  bind() {
    document.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-drawer-open]');
      const closer = event.target.closest('[data-drawer-close]');
      const qty = event.target.closest('[data-qty-change]');
      if (opener) { event.preventDefault(); this.openDrawer(); }
      if (closer) { event.preventDefault(); this.closeDrawer(); }
      if (qty) this.changeQuantity(qty);
    });
    document.addEventListener('input', (event) => {
      if (event.target.matches('[data-quantity-input]')) this.updateTotals(event.target.closest('[data-product-form]'));
    });
    document.addEventListener('change', (event) => {
      if (!event.target.matches('[data-variant-choice]')) return;
      const form = event.target.closest('[data-product-form]');
      const price = Number(event.target.dataset.price || 0);
      form?.querySelectorAll('[data-unit-price]').forEach((node) => { node.dataset.unitPrice = price; });
      form?.closest('section')?.querySelectorAll('[data-variant-price]').forEach((node) => {
        node.textContent = new Intl.NumberFormat(document.documentElement.lang || 'nl-NL', { style: 'currency', currency: node.dataset.currency || 'EUR' }).format(price / 100);
      });
      this.updateAvailability(form, event.target);
      this.updateTotals(form);
    });
    document.addEventListener('submit', (event) => {
      const protectedForm = event.target.closest('[data-pro-form]');
      if (protectedForm) {
        const trap = protectedForm.querySelector('[data-honeypot]');
        if (trap && trap.value.trim()) {
          event.preventDefault();
          protectedForm.classList.add('is-spam-blocked');
          return;
        }
      }
      const form = event.target.closest('[data-product-form]');
      if (!form || !window.fetch) return;
      event.preventDefault();
      this.addToCart(form);
    });
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape') this.closeDrawer(); });
  }
  applyChannelFunnel() {
    const body = document.body;
    if (!body || !body.classList.contains('template-index')) return;

    const params = new URLSearchParams(window.location.search);
    const source = (params.get('utm_source') || '').toLowerCase();
    const medium = (params.get('utm_medium') || '').toLowerCase();
    const content = (params.get('utm_content') || '').toLowerCase();
    const intentParam = (params.get('intent') || '').toLowerCase();

    let channel = 'organic';
    if (['facebook','instagram','meta','fb','ig'].includes(source) || params.has('fbclid')) channel = 'meta';
    if (['snapchat','snap'].includes(source) || params.has('scclid')) channel = 'snapchat';
    if (['google','bing'].includes(source) || params.has('gclid')) channel = 'search';

    let intent = 'self';
    if (intentParam === 'gift' || intentParam === 'cadeau' || content.includes('gift') || content.includes('cadeau')) intent = 'gift';

    try {
      const saved = JSON.parse(sessionStorage.getItem('utb-funnel') || '{}');
      if (channel === 'organic' && saved.channel) channel = saved.channel;
      if (intent === 'self' && saved.intent) intent = saved.intent;
      sessionStorage.setItem('utb-funnel', JSON.stringify({ channel, intent, source, medium }));
    } catch (_) {}

    body.dataset.funnelChannel = channel;
    body.dataset.funnelIntent = intent;

    const kicker = document.querySelector('[data-channel-kicker]');
    const heading = document.querySelector('[data-channel-heading]');
    const lead = document.querySelector('[data-channel-lead]');
    const context = document.querySelector('[data-channel-context]');
    const ctas = document.querySelectorAll('[data-channel-cta]');
    if (!kicker || !heading || !lead) return;

    const variants = {
      meta: {
        kicker: 'GEZIEN OP FACEBOOK OF INSTAGRAM?',
        heading: 'Eén box. Geen spoilers. Wel een uitpakmoment dat je wilt meemaken.',
        lead: 'Voor jezelf of als cadeau: je bestelt één keer en ontdekt de exacte inhoud pas wanneer de box opengaat.',
        context: 'Duidelijk vooraf: vaste prijs, geen abonnement, 14 dagen bedenktijd en de actuele verzendinformatie op de site.'
      },
      snapchat: {
        kicker: 'GEZIEN OP SNAPCHAT?',
        heading: 'Niet nog een filmpje kijken. Open er zelf één.',
        lead: 'Bestel Unpack The Box en ontdek pas thuis welke mix voor jou is ingepakt. Eén aankoop, geen abonnement.',
        context: 'Snel naar de kern: kies je box, reken veilig af en laat de inhoud nog even geheim.'
      },
      search: {
        kicker: 'UNPACK THE BOX · MYSTERYBOX',
        heading: 'Een mysterybox die vooral leuk is omdat je nog niet weet wat erin zit.',
        lead: 'Bekijk wat je vooraf wél weet: prijs, verzending, bedenktijd en de soorten producten die je kunt verwachten.',
        context: ''
      },
      gift: {
        kicker: 'EEN CADEAU DAT NIET ALLES VOORAF VERKLAAPT',
        heading: 'Voor iemand die al alles lijkt te hebben: geef het uitpakmoment cadeau.',
        lead: 'Geen voorspelbare cadeaubon. Wel een echte box waarvan de exacte inhoud pas bij het openen bekend wordt.',
        context: 'Je bestelt één keer. Geen abonnement of automatische vervolgbestelling.'
      }
    };

    const variant = intent === 'gift' ? variants.gift : variants[channel];
    if (!variant) return;
    kicker.textContent = variant.kicker;
    heading.textContent = variant.heading;
    lead.textContent = variant.lead;
    ctas.forEach((cta) => { if (!cta.disabled) cta.childNodes[0].nodeValue = 'BESTEL NU'; });
    if (context && variant.context) {
      context.textContent = variant.context;
      context.hidden = false;
    }
  }

  changeQuantity(button) {
    const root = button.closest('[data-product-form]') || button.parentElement;
    const input = root.querySelector('[data-quantity-input]');
    if (!input) return;
    const next = Math.max(1, Number(input.value || 1) + Number(button.dataset.qtyChange));
    input.value = next;
    input.dispatchEvent(new Event('input', { bubbles: true }));
  }
  updateAvailability(form, choice) {
    if (!form || !choice) return;
    const available = choice.dataset.available !== 'false';
    const inventory = Math.max(0, Number(choice.dataset.inventory || 0));
    const root = form.closest('section') || form.parentElement;
    root?.querySelectorAll('[data-stock-count]').forEach((node) => { node.textContent = inventory; });
    root?.querySelectorAll('[data-stock-status]').forEach((node) => { node.hidden = !available; });
    root?.querySelectorAll('[data-waitlist]').forEach((node) => { node.hidden = available; });
    root?.querySelectorAll('[data-buy-button]').forEach((button) => {
      button.disabled = !available;
      button.textContent = available ? (button.dataset.label || 'BESTEL NU') : 'Uitverkocht';
    });
    const sticky = document.querySelector('.sticky-buy button');
    if (sticky && root?.classList.contains('product-main')) sticky.disabled = !available;
  }
  updateTotals(scope = document) {
    const forms = scope.matches?.('[data-product-form]') ? [scope] : scope.querySelectorAll('[data-product-form]');
    forms.forEach((form) => {
      const input = form.querySelector('[data-quantity-input]');
      const output = form.querySelector('[data-total]');
      if (!input || !output) return;
      const cents = Number(output.dataset.unitPrice || 0) * Number(input.value || 1);
      output.textContent = new Intl.NumberFormat(document.documentElement.lang || 'nl-NL', { style: 'currency', currency: output.dataset.currency || 'EUR' }).format(cents / 100);
    });
  }
  async addToCart(form) {
    const submit = form.querySelector('[type="submit"]');
    const original = submit.textContent;
    submit.disabled = true; submit.textContent = form.hasAttribute('data-direct-checkout') ? 'Even verwerken…' : 'Even verwerken…';
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) });
      if (!response.ok) throw new Error('Product kon niet worden toegevoegd');
      if (form.hasAttribute('data-direct-checkout')) {
        window.location.assign(`${window.Shopify?.routes?.root || '/'}checkout`);
        return;
      }
      await this.refreshDrawer();
      this.openDrawer();
    } catch (error) {
      submit.textContent = error.message;
      setTimeout(() => { submit.textContent = original; }, 2500);
    } finally { submit.disabled = false; if (submit.textContent === 'Even verwerken…') submit.textContent = original; }
  }
  async refreshDrawer() {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}?section_id=cart-drawer`);
    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('[data-cart-drawer]');
    if (fresh && this.drawer) { this.drawer.innerHTML = fresh.innerHTML; }
    const count = fresh?.dataset.cartTotalItems;
    document.querySelectorAll('[data-cart-count]').forEach(el => { if (count !== undefined) el.textContent = count; });
  }
  openDrawer() {
    if (!this.drawer) return;
    this.drawer.classList.add('is-open'); this.drawer.setAttribute('aria-hidden', 'false');
    this.scrim.hidden = false; document.body.classList.add('drawer-open');
    this.drawer.querySelector('button, a')?.focus();
  }
  closeDrawer() {
    if (!this.drawer) return;
    this.drawer.classList.remove('is-open'); this.drawer.setAttribute('aria-hidden', 'true');
    this.scrim.hidden = true; document.body.classList.remove('drawer-open');
  }
}
document.addEventListener('DOMContentLoaded', () => new UtpTheme());
